import { PropertyStatusType } from './PropertyStatusType';

export const PropertyStatusTypeOptions = [
    {
        id: PropertyStatusType.Pending,
        name: 'Pending',
        shortName: 'Pending',
    },
    {
        id: PropertyStatusType.Appraise,
        name: 'Bfi To Order',
        shortName: 'Bfi To Ordr',
    },
    {
        id: PropertyStatusType.AppraisalOrdered,
        name: 'Appraisal Ordered',
        shortName: 'Ordered',
    },
    {
        id: PropertyStatusType.AppraisalReceived,
        name: 'Appraisal Received',
        shortName: 'Appr. Received',
    },
    {
        id: PropertyStatusType.AppraisalReviewed,
        name: 'Appraisal Reviewed',
        shortName: 'Appr. Reviewed',
    },
    {
        id: PropertyStatusType.Approved,
        name: 'Converted to Loan',
        shortName: 'Cnvtd to Ln',
    },
    {
        id: PropertyStatusType.Deleted,
        name: 'Prop. Deleted',
        shortName: 'Prop Dltd',
    },
];
